export function ensureTarget(target, to) {
  if (target) return target;
  return to && to[0] === '/' ? undefined : '_blank';
}
